import React , {useState , useEffect} from 'react'
// import WorkersComponent from './WorkersComponent';

import PackageComponent from './PackageComponent';
import Skeleton , {SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { AppContext } from '../context/AppContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const LocationSlideFive = () => {

    let navigate = useNavigate();

  const [loading , setLoading] = useState(false);
  const {slideIndex} = useContext(AppContext);
  const [ indexSlideValue , setIndexSlideValue ] = slideIndex;

  const {photographers} = useContext(AppContext);
  const {hotels} = useContext(AppContext);
  const { tours } = useContext(AppContext);

  const [photographersArray] = photographers;
  const [hotelArray] = hotels;
  const [tourGuideArray] = tours;

  let starsArray = [];

  const loopThrought = (param) => {
      for (let i =0; i < param; i++ ) {
          starsArray.push(i);
      }
     
  }

 useEffect(() => {

    setLoading(true);

    setTimeout(() => {
       setLoading(false);
    } , 600)

 } , [])
  




  return (
    <div className="main_slide_two">

    <div className='container-sm' >

    <div className="top_area_slide_two"></div>
    <h1 className='location_slidetwo_headline' >  قم برحلتك لهذا المكان معنا</h1>



      {/* <div className="d-flex-c f-sv f-wrap categories_sections mt-2">

        <button className="btn_category" onClick={() => setQuerySearch( 'photography') } >مصورين</button>

        <button className="btn_category" onClick={() => setQuerySearch( 'hotel') } >الفنادق</button>
      
        <button className="btn_category" onClick={() => setQuerySearch('tour_guide') } >مرشدين</button>
  
      </div> */}

        <div className="shopping_categories_div mt-5">

        {/* {workersArray && (
          workersArray.map(( { id ,name , image , price , bio , link , job } ) => (
            <WorkersComponent id={id} name={name} image={image} item_price={price} bio={bio} link={link} job={job} />
          ))
        )} */}

        {loading ? (
          <>
          <SkeletonTheme baseColor="#e9e9e9" highlightColor="#e9e9e9">
    <p>
      <Skeleton height={'20%'} width={'100%'} count={5} />
    </p>
  </SkeletonTheme>
                            </>
        ) : (

          <div>

          <h1 className="location_slidetwo_headline text-right mt-2 mb-2"> بكجات المصورين </h1>
          {photographersArray && photographersArray.map(({  id , service_name , service_desc , service_provider  , price , rating , image }) => (
            <PackageComponent id={id} service_name={service_name} service_desc={service_desc} service_provider={service_provider} item_price={price} rating={rating} image={image} />
          ))}

          <h1 className="location_slidetwo_headline text-right mt-2 mb-2"> بكجات الفنادق </h1>
          {hotelArray && hotelArray.map(({  id , service_name , service_desc , service_provider  , price , rating , image }) => (
            <PackageComponent id={id} service_name={service_name} service_desc={service_desc} service_provider={service_provider} item_price={price} rating={rating} image={image} />
          ))}

          <h1 className="location_slidetwo_headline text-right mt-2 mb-2"> بكجات المرشدين </h1>
          {tourGuideArray && tourGuideArray.map(({  id , service_name , service_desc , service_provider  , price , rating , image }) => (
            <PackageComponent id={id} service_name={service_name} service_desc={service_desc} service_provider={service_provider} item_price={price} rating={rating} image={image} />
          ))}

          </div>
        )}
       

        <div className="f-sv d-flex-c sliding_btns mt-3 ">
              <button className="btn_category bg_red " onClick={() => setIndexSlideValue(indexSlideValue - 1) } > السابق </button>
                <button className="btn_category bg_green" onClick={() => navigate('/confirm-order') } > تأكيد </button>
              </div>
        </div>


     

    </div>


      


    </div>
  )
}

export default LocationSlideFive